import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const lifetime = 24 * 60 * 60 * 1000;
export const readDraft = (storage, key, fallback) => {
  try {
    const saved = JSON.parse(storage.getItem(key));
    return saved && Date.now() - saved.at < lifetime ? { ...fallback, ...saved.value } : fallback;
  } catch { return fallback; }
};
export const withoutImages = (value) => Object.fromEntries(Object.entries(value)
  .filter(([key]) => !/image|photo/i.test(key)));

// Tab-local, account-scoped recovery. Images and credentials never enter draft storage.
export default function useDraft(name, initial) {
  const user = useSelector((state) => state.session.user);
  const key = `draft.${user?.tenantId}.${user?.id}.${name}`;
  const [value, setValue] = useState(() => readDraft(window.sessionStorage, key, initial));
  const [storageError, setStorageError] = useState(false);
  useEffect(() => {
    try { window.sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), value: withoutImages(value) })); setStorageError(false); } catch { setStorageError(true); }
  }, [key, value]);
  const discard = () => { try { window.sessionStorage.removeItem(key); } catch { /* unavailable storage */ } setValue(initial); };
  return [value, setValue, discard, storageError];
}
